import { opt } from '../lib/media';
import React, { useEffect, useState } from 'react';
import { LOGO_URL } from '../mock';

export default function SplashScreen({ onFinish }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), 3200);
    const t2 = setTimeout(() => onFinish && onFinish(), 4300);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onFinish]);

  return (
    <div className={`splash-root ${leaving ? 'splash-leaving' : ''}`}>
      <div className="splash-inner">
        <div className="splash-logo-wrap">
          <img src={opt(LOGO_URL, 240)} alt="HITÉRA" className="splash-logo" />
          <div className="splash-glow" />
        </div>
        <div className="splash-line" />
        <p className="splash-tag">C O U T U R E &nbsp;&middot;&nbsp; C R A F T E D &nbsp; I N &nbsp; I N D I A</p>
      </div>
    </div>
  );
}
